// Copyright 2016 Sorama B.V.

export class ObjectCacheService<TCachedObject> {
    public cachedObjects: TCachedObject[];

    constructor() {
        this.cachedObjects = [];
    }
}
